import { IFilterOperator } from 'core-components/types'

export interface IFieldFilter {
  field: string
  operator: IFilterOperator
  value: string
}

export interface IDataTableSettings {
  uniqueKey: string
  sortField: string
  sortDirection: 'asc' | 'desc'
  visibleColumns: string[]
  filters: IFieldFilter[]

  settingsAvailable: boolean
  sortAvailable: boolean
  filterAvailable: boolean
  visibleAvailable: boolean
  editableAvailable?: boolean
}

export type IFilterOptions = Array<{ operator: IFilterOperator; label: string }>

export const filterOptions: IFilterOptions = [
  { operator: 'eq', label: 'Is equal to' },
  { operator: 'neq', label: 'Is not equal to' },
  { operator: 'startswith', label: 'Starts with' },
  { operator: 'endswith', label: 'Ends with' },
  { operator: 'contains', label: 'Contains' },
  { operator: 'doesnotcontain', label: 'Does not contain' },
  { operator: 'isnull', label: 'Is null' },
  { operator: 'isnotnull', label: 'Is not null' },
  { operator: 'isempty', label: 'Is empty' },
  { operator: 'isnotempty', label: 'Is not empty' },
]
